export default theme => ({
    warning: {
        color: theme.palette.error.main,
        fontStyle: 'italic',
    },
    confirm: {
        fontWeight: 'bold',
    },
});
